import React, { lazy, Suspense } from 'react';

const Login = lazy(() => import('./Login'));
const Dashboard = lazy(() => import('./Dashboard'));
const Teams = lazy(() => import('./Teams'));
const Messages = lazy(() => import('./Messages'));
const Team = lazy(() => import('./Teams/team'));

const routes = [
  {
    path: '/',
    exact: true,
    main: () => <Login />,
  },
  {
    path: '/login',
    exact: true,
    main: () => <Login />,
  },
  {
    path: '/dashboard',
    exact: true,
    main: () => <Dashboard />,
  },
  {
    path: '/messages',
    exact: true,
    main: () => <Messages />,
  },
  {
    path: '/teams',
    exact: true,
    main: () => <Teams />,
  },
  {
    path: '/team/:id',
    exact: true,
    main: () => <Team />,
  },
];

export default routes;
